import React from 'react';
import { useHistory } from 'react-router-dom';
import cx from 'classnames';
import { Switch } from 'components';
import { useIsProActivated, useReadOnlyWarning } from 'hooks';
import { useCurrentSafe } from 'store';
import { ITrackingSettingsData, ITrackingSettingsFlag } from 'types';

type Props = {
  safeSettings: ITrackingSettingsData;
  handleChangeFlag: (safeId: string, flagName: ITrackingSettingsFlag) => void;
};

export const PrivacySettings: React.FC<Props> = ({ safeSettings, handleChangeFlag }) => {
  const history = useHistory();
  const { currentSafe } = useCurrentSafe();
  const isActivatedPro = useIsProActivated();
  const readOnlyWarning = useReadOnlyWarning();

  return (
    <div className="flex flex-col p-24 gap-12 sm:gap-32 rounded-[12px] border-[.5px] border-[#FFE341] bg-[linear-gradient(91deg,_#1C190C_0%,_#14100C_100%)]">
      <div className="flex flex-col items-start gap-12">
        <div className="flex items-center gap-8">
          <p className="text-m16 text-white">Privacy mode</p>
          {/* <div className="rounded-[24px] bg-[linear-gradient(103deg,_#FFE341_0%,_#F7E47D_24.5%,_#F1C855_48.99%,_#FFE2A8_73.49%,_#FFE970_97.99%)] w-44 h-24 flex items-center text-[#493B15] justify-center">
            Pro
          </div> */}
        </div>
        <div className="text-r13 sm:text-r14">
          Enable Privacy Mode to ensure your Vault details remain private. This feature hides your
          Vault from being accessed via URL, preventing others from viewing transaction history,
          message signature details, balance and assets details, and owner permissions.
        </div>
        {!isActivatedPro && (
          <div>
            <button
              className="text-primary"
              onClick={() => history.push(`/vault/${currentSafe?.address}/pro`)}
            >
              Upgrade
            </button>{' '}
            to Pro to Enable Privacy Mode.
          </div>
        )}
      </div>
      <div className={cx('flex gap-16 items-center')}>
        <Switch
          onCheck={() => handleChangeFlag(currentSafe?._id || '', 'isPrivacyMode')}
          checked={isActivatedPro ? safeSettings.isPrivacyMode : false}
          disabled={Boolean(readOnlyWarning) || !isActivatedPro}
          disabledHint={readOnlyWarning}
          hintPosition="bottom-start"
        >
          Privacy mode
        </Switch>
      </div>
    </div>
  );
};
